<template lang="pug">
    div
        div.l-flex-row--between.header
            h1.section-header--title.flex-1 Sharing
                select.sharing-settings-select(v-model="currentSharingType")
                    option(name="audiences" value="audiences") audiences
                    option(name="taxonomies" value="taxonomies") taxonomies
            div.section-header--action-item.action-item-direct
                button.btn-save-mt.btn--small.btn--round.l-flex-row.l-align-center(:class="{'ui-disabled': !sharingPayloadCount > 0}" @click="handleBulkActivateSharing") Save
                    span(v-if="sharingPayloadCount > 0") {{'(' + this.sharingPayloadCount + ')'}}
        div.subheader Allow accounts to share their audiences or taxonomies
        Table(v-show="currentSharingType === 'taxonomies'"
            :fullData="sharingSettings.taxonomies"
            :tableData="taxonomyTableDataSharing"
            :selectRow="setSelectedRow"
            :selectedRowId="selectedRowId"
            :displaySearch="true"
            :displayFilters="false"
            searchPlaceHolder="Search for sharing by id or account name"
            :searchFilters="searchFilters")
        Table(v-show="currentSharingType === 'audiences'"
            :fullData="sharingSettings.audiences"
            :tableData="audienceTableDataSharing"
            :selectRow="setSelectedRow"
            :selectedRowId="selectedRowId"
            :displaySearch="true"
            :displayFilters="false"
            searchPlaceHolder="Search for sharing by id or account name"
            :searchFilters="searchFilters")

</template>

<script>
//components
import Table from '@/components/common/Table'

//store
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import { cloneDeep } from 'lodash'
import {
    SETTINGS_AUDIENCE_SHARING_TABLE_PROPS,
    SETTINGS_TAXONOMY_SHARING_TABLE_PROPS,
    SHARING_SEARCH_PROPS,
} from '@/utils/constants'

export default {
    components: {
        Table,
    },

    data() {
        return {
            settingsMenu: 'sharing',
            audienceTableDataSharing: {
                config: SETTINGS_AUDIENCE_SHARING_TABLE_PROPS.config,
                pagination: {
                    currentPage: SETTINGS_AUDIENCE_SHARING_TABLE_PROPS.pagination.currentPage,
                    currentPageSize: SETTINGS_AUDIENCE_SHARING_TABLE_PROPS.pagination.rowPerPage
                },
                sorting: {
                    key: 'audience_sharing',
                    order: 'asc'
                },
                opened: []
            },
            taxonomyTableDataSharing: {
                config: SETTINGS_TAXONOMY_SHARING_TABLE_PROPS.config,
                pagination: {
                    currentPage: SETTINGS_TAXONOMY_SHARING_TABLE_PROPS.pagination.currentPage,
                    currentPageSize: SETTINGS_TAXONOMY_SHARING_TABLE_PROPS.pagination.rowPerPage
                },
                sorting: {
                    key: 'wam_custom_taxonomy_sharing',
                    order: 'asc'
                },
                opened: []
            },
            searchFilters: cloneDeep(SHARING_SEARCH_PROPS),
            currentSharingType: 'audiences',
            processing: false
        }
    },

    watch: {
        currentSharingType: {
            handler: function(newValue) {
                this.setSharingType({ sharingType: newValue })
                this.setDefaultActiveSharing({ alreadyActiveSharing: this.getActiveSharing({ sharingType: newValue }) })
                this.resetSharings()
            }
        },
    },

    computed: {
        ...mapState('data/settings', {
            sharingSettings: state => state.sharing
        }),
        ...mapState('ui/settings', {
            selectedRowId: state => state.selectedRowId,
            uiSharingSettings: state => state.sharing,

        }),
        ...mapGetters('ui/settings', ['getActiveSharing']),


        sharingPayloadCount() {
            return this.uiSharingSettings.sharingToAdd.length + this.uiSharingSettings.sharingToRemove.length
        }
    },

    methods: {
        ...mapActions('data/settings', [
            'requestActivateSharing'
        ]),

        ...mapMutations('ui/settings', [
            'setSelectedRow',
            'setSharingType',
            'setDefaultActiveSharing',
            'resetSharings',
        ]),

        handleBulkActivateSharing() {
            const sharingType = this.uiSharingSettings.sharingType === 'taxonomies' ? 'wam_custom_taxonomy' : 'audience'
            this.requestActivateSharing({ linked_account_ids: this.uiSharingSettings.activeSharing, sharing_type: sharingType })
        },

    }
}
</script>